/** 매장 - 업종 */
export const storeCategories = {
  salad_cafe: '샐러드·카페',
  korean: '한식',
  barbeque_jokbal: '고기·족발·보쌈',
  chicken_pizza: '치킨·피자',
  japanese: '일식·돈까스·회',
  western: '양식',
  chinese: '중식',
  asian: '아시안',
  fastfood: '버거',
  snack: '분식',
  all: '전체',
  etc: '기타',
};
export type StoreCategory = keyof typeof storeCategories;

export const storeStateList = {
  guest: '승인대기',
  open: '운영',
  break: '휴업',
  closed: '폐업',
};
export type StoreState = keyof typeof storeStateList;

/**
 * 굿엉클스 하남 감북동 창고 좌표
 */
export const goodunclesCoords = {
  // 위도
  lat: 37.52342649839478,
  // 경도
  lng: 127.16741757398434,
};

/**
 * 서울시 좌표 범위
 */
export const seoulCoordsRange = {
  lat: {
    min: 37.413294,
    max: 37.715133,
  },
  lng: {
    min: 126.734086,
    max: 127.269311,
  },
};
